import useTranslation from 'next-translate/useTranslation';

import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';

type UpsellCrownIconProps = {
    className?: string;
    tooltip?: string;
};

export const UpsellCrownIcon = ({ className, tooltip }: UpsellCrownIconProps) => {
    const { t } = useTranslation('commons');

    return (
        <Tooltip
            content={tooltip ?? t('upsell_modal.hint')}
            interactive={true}
            appendTo={() => document.body}
            placement="right"
            className={className}>
            <Icon icon="crown" className="ml-1 text-icoBlue" />
        </Tooltip>
    );
};
